module.exports = __webpack_public_path__ + "assets/img/paypal (1).1c1d11a2.png";